export default [
    {
        path: "/",
        name: "home",
        component: () => import("../views/lyx-pages/home/index")
    },

    //写游记
    {
        path: '/travels-notes',
        name: 'travelsNotes',
        component: () => import('../views/lyx-pages/travelsNotes/write.vue'),
        meta: {
            title: '写游记',
            intercept: true
        }
    },
    {
        path: '/travel-content',
        name: 'travelContent',
        component: () => import('../views/lyx-pages/travelsNotes/travelContent.vue'),
        meta: {
            title: '我的游记',
            intercept: true
        }
    },
    {
        path: '/my-strategy',
        name: 'myStrategy',
        component: () => import('../views/lyx-pages/strategy/myStrategy-personal.vue'),
        meta: {
            title: '攻略列表',
            intercept: true
        }
    },
    {   // 攻略简介
        path: '/strDesViewNew',
        name: 'strDesViewNew',
        component: () => import('../views/lyx-pages/strategy/strategy-destination-view/index.vue'),
        meta: {
            title: '攻略详情'
        }
    },
    {
        path: '/change-strategy-content',
        name: 'changeStrategyContent',
        component: () => import('../views/lyx-pages/strategy/changeStrategyContent.vue'),
        meta: {
            title: '修改攻略',
            intercept: true
        }
    },
    {
        path: '/strategy-content',
        name: 'strategyContent',
        component: () => import('../views/lyx-pages/strategy/strategyContent.vue'),
        meta: {
            title: '发布攻略',
            intercept: true
        }
    },
    {
        path: '/select-sites',
        name: 'selectSites',
        component: () => import('../views/lyx-pages/writeDetail/selectSites.vue'),
        meta: {
            title: '关联场所',
            intercept: true
        }
    },

    // 搜索
    {
        path: "/search",
        name: "search",
        component: () => import("../views/lyx-pages/search/index.vue")
    },
    {  //景区导游导览
        path: "/guideOne/:id",
        name: "guide-one",
        component: () => import("../views/lyx-pages/guide-one/index")
    },
    {  //导游导览
        path: "/guide",
        name: "guide",
        component: () => import("../views/lyx-pages/guide/index")
    },
    {  // 登录

        path: '/login',
        name: 'login',
        component: () => import('../views/lyx-pages/login/index')
    },
    {  // 微信绑定手机号
        path: '/relation',
        name: 'center-relation',
        component: () => import('../views/lyx-pages/center-relation/index.vue')
    },
    {   // 个人中心
        path: '/center',
        name: 'center',
        component: () => import('../views/lyx-pages/center-default/index.vue'),
        meta: { intercept: true }
    },
    {   // 系统设置
        path: '/set',
        name: 'centerSet',
        component: () =>
            import('../views/lyx-pages/center-set/index.vue'),
        meta: { intercept: true }
    },
    {   // 浏览记录
        path: '/history',
        name: 'history',
        component: () =>
            import('../views/lyx-pages/center-history/index.vue'),
        meta: { intercept: true }
    },
    {   // 咨询投诉
        path: '/complaintImtion',
        name: 'complaintImtion',
        component: () => import('../views/lyx-pages/complaint-imtion/index.vue')
    },
    {   // 在线投诉
        path: '/theComplaint',
        name: 'theComplaint',
        component: () => import('../views/lyx-pages/the-complaint/index.vue'),
        meta: { intercept: true }
    },
    {  // 我的投诉
        path: '/complaintList',
        name: 'complaintList',
        component: () => import('../views/lyx-pages/complaint-list/index.vue'),
        meta: { intercept: true }
    },
    {   // 投诉详情
        path: '/complaintDetails/:id',
        name: 'complaintDetails',
        component: () => import('../views/lyx-pages/complaint-details/index.vue'),
        meta: { intercept: true }
    },
    // 写评价
    {
        path: "/evaluation/:id/:appCode/:moduleCode/:name",
        name: "evaluation",
        component: () => import("../views/lyx-pages/evaluation/index.vue"),
        meta: { intercept: true }
    },
    {  // 我的点评
        path: '/commentList',
        name: 'my-comment-list',
        component: () => import('../views/lyx-pages/eval-alllist/index.vue'),
        meta: { intercept: true }
    },
    {   // 智能问答
        path: '/consultation',
        name: 'consultation',
        component: () => import('../views/lyx-pages/question-answer/index.vue'),
    },
    // 全景列表
    {
        path: "/panoramaList",
        name: "panoramaList",
        component: () => import("../views/lyx-pages/panorama-list/index.vue")
    },
    // 新闻资讯
    {
        path: "/information",
        name: "information",
        component: () => import("../views/lyx-pages/information/index.vue")
    },
    // 新闻详情
    {
        path: "/news-details",
        name: "news-details",
        component: () => import("../views/lyx-pages/news-details/index.vue")
    },
    // 慢直播列表
    {
        path: "/directList",
        name: "directList",
        component: () => import("../views/lyx-pages/direct-list/index.vue")
    },
    // 视频列表
    {
        path: "/videoList/:tab",
        name: "videoList",
        component: () => import("../views/lyx-pages/video-list/index.vue")
    },
    // 农家乐列表
    {
        path: "/agritainmentList",
        name: "agritainmentList",
        component: () => import("../views/lyx-pages/njl-list/index.vue")
    },
    // 农家乐详情
    {
        path: "/agritainmentDetails/:id",
        name: "agritainmentZDetails",
        component: () => import("../views/lyx-pages/njl-details/index.vue")
    },
    // 乡村游列表
    {
        path: "/rural",
        name: "rural",
        component: () => import("../views/lyx-pages/rural/index.vue")
    },
    // 最美乡村列表
    {
        path: "/village",
        name: "village",
        component: () => import("../views/lyx-pages/village/index.vue")
    },
    {   // 最美乡村详情 
        path: '/villageView/:id',
        name: 'villageView',
        component: () => import('../views/lyx-pages/village-view/index')
    },
    {  //景区列表
        path: "/scenicList",
        name: "scenicList",
        component: () => import("../views/lyx-pages/scenic-list/index")
    },
    {   // 景区详情 
        path: '/scenicView/:id',
        name: 'scenicView',
        component: () => import('../views/lyx-pages/scenic-view/index')
    },
    // 景点详情
    {
        path: "/spotView/:id",
        name: "spotView",
        component: () => import("../views/lyx-pages/spot-view/index.vue")
    },
    // 酒店列表
    {
        path: "/hotelList",
        name: "hotelList",
        component: () => import("../views/lyx-pages/hotel-list/index.vue")
    },
    // 酒店详情
    {
        path: "/hotelDetails/:id",
        name: "hotelDetails",
        component: () => import("../views/lyx-pages/hotel-details/index.vue")
    },
    {  //美食
        path: "/delicious-food",
        name: "delicious-food",
        component: () => import("../views/lyx-pages/delicious-food/index")
    },
    {   // 美食详情
        path: '/specialDetails/:type/:id',
        name: 'special-details',
        component: () => import('../views/lyx-pages/special-details/index.vue')
    },
    {   // 商家介绍
        path: '/businessView/:code/:id',
        name: 'business-view',
        component: () => import('../views/lyx-pages/business-view/index.vue')
    },
    {        // 游记列表
        path: "/strategyList/:tab",
        name: "strategyList",
        component: () =>
            import("../views/lyx-pages/strategy-list/index")
    },
    // 游记详情
    {
        path: "/strategyDetails/:id",
        name: "strategyDetails",
        component: () =>
            import("../views/lyx-pages/strategy-details/index")
    },
    {  //攻略列表
        path: "/strList",
        name: "strList",
        component: () => import("../views/lyx-pages/new-strategy-list/index")
    },
    {   // 攻略简介
        path: '/strDesView/:tab/:name/:tag',
        name: 'strDesView',
        component: () =>
            import('../views/lyx-pages/strategy-destination-view/index.vue')
    },
    {   // 攻略详情
        path: '/strDesSelView/:id/:idx1/:idx2',
        name: 'strDesSelView',
        component: () =>
            import('../views/lyx-pages/strategy-destination-selected-view/index.vue')
    },
    {
        //周边游
        path: '/peripheral',
        name: 'peripheral',
        component: () => import('../views/lyx-pages/peripheral/index.vue')
    },
    // 精品线路
    {
        path: '/goodRoute',
        name: 'goodRoute',
        component: () => import('../views/lyx-pages/route/route-goodroute/index.vue'),
        meta: {
            deepth: 2.5
        }
    },
    // 线路详情
    {
        path: '/routeDetails',
        name: 'routeDetails',
        component: () => import('../views/lyx-pages/route/route-details/index.vue'),
        meta: {
            deepth: 4
        }
    },
    {  //购物
        path: "/shopping",
        name: "shopping",
        component: () => import("../views/lyx-pages/shopping/index")
    },
    {  // 商品详情
        path: "/product-details/:id",
        name: "product-details",
        component: () => import("../views/lyx-pages/product-details/index")
    },
    {  // 城市服务
        path: "/cityServices",
        name: "cityServices",
        component: () => import("../views/lyx-pages/city-services/index")
    },
    {
        //周边服务
        path: '/circum/:index',
        name: 'circum',
        component: () => import('../views/lyx-pages/circum/index.vue')
    },
    {
        //一键救援
        path: '/onekeyRescue',
        name: 'onekeyRescue',
        component: () => import('../views/lyx-pages/onekey-rescue/index.vue')
    },
    {
        //天气
        path: '/weather',
        name: 'weather',
        component: () => import('../views/lyx-pages/weather/index.vue')
    },
    {
        //行程定制 start
        path: '/travel-choice',
        name: 'travel-choice',
        component: () => import('../views/lyx-pages/xj-travel/travel-choice/index.vue'),
        meta: { intercept: true }
    },
    {
        //行程偏好
        path: '/travel-preference',
        name: 'travel-preference',
        component: () => import('../views/lyx-pages/xj-travel/travel-preference/index.vue'),
        meta: { intercept: true }
    },
    {
        //出游意向
        path: '/travel-intention',
        name: 'travel-intention',
        component: () => import('../views/lyx-pages/xj-travel/travel-intention/index.vue'),
        meta: { intercept: true }
    },
    {
        //行程景点
        path: '/choose-spot',
        name: 'choose-spot',
        component: () => import('../views/lyx-pages/xj-travel/choose-spot/index.vue'),
        meta: { intercept: true }
    },
    {
        //行程景点
        path: '/data-compute',
        name: 'data-compute',
        component: () => import('../views/lyx-pages/xj-travel/data-compute/index.vue'),
        meta: { intercept: true }
    },
    {
        //行程景点
        path: '/travel-profile/:id',
        name: 'travel-profile',
        component: () => import('../views/lyx-pages/xj-travel/travel-profile/index.vue'),
        meta: { intercept: true }
    },
    {
        //热门城市
        path: '/choose-scenic',
        name: 'choose-scenic',
        component: () => import('../views/lyx-pages/xj-travel/choose-scenic/index.vue'),
        meta: { intercept: true }
    },
    {
        //行程详情
        path: '/travel-details/:index/:id',
        name: 'travel-details',
        component: () => import('../views/lyx-pages/xj-travel/travel-details/index.vue'),
        meta: { intercept: true }
    },
    {
        //添加景区
        path: '/add-scenic/:cityId',
        name: 'add-scenic',
        component: () => import('../views/lyx-pages/xj-travel/add-scenic/index.vue'),
        meta: { intercept: true }
    },
    {
        //行程地图
        path: '/map-days/:id',
        name: 'map-days',
        component: () => import('../views/lyx-pages/xj-travel/map-days/index.vue'),
        meta: { intercept: true }
    },
    {
        //我的行程
        path: '/my-trip-list',
        name: 'my-trip-list',
        component: () => import('../views/lyx-pages/xj-travel/my-trip-list/index.vue'),
        meta: { intercept: true }
    },

    {
        path: "/evalAlllist/:appCode/:moduleCode/:id",
        name: "evalAlllist",
        component: () => import("../views/lyx-pages/eval-alllist/index.vue")
    },
    {
        //
        path: '/travel-days',
        name: 'travel-days',
        component: () => import('../views/lyx-pages/xj-travel/travel-days/index.vue'),
        meta: { intercept: true }
    },
    {
        //
        path: '/strategy-mode/:id',
        name: 'strategy-mode',
        component: () => import('../views/lyx-pages/xj-travel/strategy-mode/index.vue'),
        meta: { intercept: true }
    },
    //电商
    //门票预订
    {
        path: '/tickethjly',
        name: 'tickethjly',
        component: () => import('../views/lyx-pages/admission-ticket/ticket-hjly/index.vue'),
        meta: { intercept: true }
        // meta: {
        //     deepth: 4
        // }
    },
    //门票已支付
    {
        path: '/ticketPlay/:mainOrderId/:orderType/:orderId',
        name: 'ticketPlay',
        component: () => import('../views/lyx-pages/admission-ticket/ticket-play/index.vue'),
    },
    //编辑、新增游玩人
    {
        path: '/addContact',
        name: 'addContact',
        component: () => import('../views/lyx-pages/admission-ticket/add-contact/index.vue'),
    },
    // 选择支付方式
    {
        path: "/methodPay",
        name: "methodPay",
        component: () => import("../views/lyx-pages/admission-ticket/method-pay/index.vue"),
    },
    // 我的订单
    {
        path: "/myOrder",
        name: "myOrder",
        component: () => import("../views/lyx-pages/admission-ticket/my-order/index.vue"),
    },
    // 申请退款
    {
        path: '/refundProduct/:mainOrderId/:orderId/:type/:orderType',
        name: 'refundProduct',
        component: () => import('../views/lyx-pages/admission-ticket/refund-product/index.vue')
    },
    // 非遗
    {
        path: '/legacy',
        name: 'legacy',
        component: () => import('../views/lyx-pages/legacy/index.vue')
    },
    // 非遗详情
    {
        path: '/legacyDetail',
        name: 'legacyDetail',
        component: () => import('../views/lyx-pages/legacy-detail/index.vue')
    },
    // 文博专题
    {
        path: '/culture',
        name: 'culture',
        component: () => import('../views/lyx-pages/culture/index.vue')
    },
    // 文博专题详情
    {
        path: '/cultureDetail',
        name: 'cultureDetail',
        component: () => import('../views/lyx-pages/culture-detail/index.vue')
    },
    // 生态专题
    {
        path: '/ecological',
        name: 'ecological',
        component: () => import('../views/lyx-pages/ecological/index.vue')
    },
    // 生态专题详情
    {
        path: '/ecologicalDetail',
        name: 'ecologicalDetail',
        component: () => import('../views/lyx-pages/ecological-detail/index.vue')
    },
    // numSpecial
    {
        path: '/numSpecial',
        name: 'numSpecial',
        component: () => import('../views/lyx-pages/numSpecial/index.vue')
    },
    {
        // 时空图谱/区县
        path: "/ichDetails/:id",
        name: "ichDetails",
        component: () => import("../views/lyx-pages/legacy/ich/details.vue"),
    },
];
